import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
};

/**
 * Session state.
 * - correctCount: rounds solved (green dots earned). Win when it reaches WIN_DOTS.
 * - gameOver:     true if the 9 scored rounds finished with < WIN_DOTS greens.
 *                 EndScene reads it to pick game-over vs reward.
 *
 * The tutorial + 9 generated rounds and the per-round life count live on the
 * GameScene instance (generated fresh each play), so they are not stored here.
 */
export const gameState = {
  correctCount: 0,
  gameOver: false,
};

export function resetGameState() {
  gameState.correctCount = 0;
  gameState.gameOver = false;
}
